const faqData = [
  {
    q: '黑料吃瓜在线是什么类型的网站？',
    a: '黑料吃瓜在线是一个娱乐八卦资讯聚合平台，致力于实时汇总全网娱乐圈、网红圈、综艺圈等领域的黑料爆料与吃瓜内容。我们聚合 30+ 主流信息源，每日更新 200+ 条热点动态，为用户提供一站式八卦浏览体验。所有内容均来自公开渠道，仅供娱乐参考。',
  },
  {
    q: '网站上的内容是真实的吗？',
    a: '本平台所有内容均来自互联网公开渠道的聚合整理，我们会在信息卡片中标注来源线索。但由于八卦信息的特殊性，我们无法对每一条内容的真实性做逐一核实。建议理性吃瓜，不要轻信未经证实的传闻，也不要将平台内容作为事实依据进行传播。',
  },
  {
    q: '信息更新频率是怎样的？',
    a: '我们采取 7×24 小时不间断的监控和更新机制。热点事件爆发后通常在 5 分钟内即可同步上线，常规内容每小时滚动更新一批。日均更新量超过 200 条，确保你打开网站就能看到最新鲜的内容。',
  },
  {
    q: '需要注册才能浏览吗？',
    a: '完全不需要！黑料吃瓜在线坚持零门槛浏览，打开网站即可查看全部内容。我们不设注册墙、不搞会员制、不限制每日阅读数量，真正做到即开即看，给你最清爽的吃瓜体验。',
  },
  {
    q: '我可以投稿或爆料吗？',
    a: '欢迎投稿！你可以通过页面底部的联系入口将你掌握的爆料信息发送给我们。请尽量附带来源线索或截图证据，我们的编辑团队审核后会酌情发布。请注意，我们拒绝发布恶意造谣、人身攻击和侵犯隐私的内容。',
  },
  {
    q: '手机端可以使用吗？',
    a: '当然！本网站采用响应式设计，完美适配手机、平板和桌面端。无论你是在通勤路上还是摸鱼时刻，打开手机浏览器即可流畅浏览。我们也在积极推进移动端专属入口的优化，敬请期待。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于黑料吃瓜在线，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2">
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}